import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    value: 13,
    image: 'https://cdn.magicpatterns.com/uploads/2badsTisbq4G6GTw6mQLpY/portada_bono_3.png',
    title: 'TRACKER 72H CLARO',
    subtitle: 'Energía + Abdomen + Claridad (30 segundos al día)',
    description: 'Este es el bono que hace que todo lo anterior se vuelva real y visible. Lo que se mide, se sostiene. Y cuando ves que el día 2 tu claridad mental subió de 2 a 4, y que tu abdomen ya no presiona contra la ropa, tu motivación se dispara sola. El Tracker 72H te da esa evidencia en 30 segundos, dos veces al día.',
    includes: ['Tracker de mañana y noche para los 3 días del reset', '5 métricas clave: hinchazón, presión, energía, claridad mental y digestión', 'Escala 1–5 (sin ambigüedad, sin perder tiempo)', 'Semáforo de decisiones: verde / amarillo / rojo', 'Guía "si pasa esto, hacé esto" (micro ajustes en tiempo real)', 'Revisión final 72H para identificar qué repetir y qué evitar', 'Plan de repetición (tu "botón de reinicio" personal)', 'Versión móvil (rellenable) + imprimible'],
    why: 'Porque sin seguimiento, los resultados son invisibles y la gente abandona pensando que "no funcionó". Este tracker convierte sensaciones vagas en datos claros que te mantienen en el camino.'
  }];
  return <section className="py-12 md:py-24 bg-cream relative overflow-hidden" data-id="element-31">
      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-32">
        <div className="text-center mb-8 md:mb-16" data-id="element-33">
          <FadeIn data-id="element-34">
            <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-forest font-semibold text-sm tracking-wider mb-6 uppercase" data-id="element-35">
              Y ESO NO ES TODO...
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-8 leading-tight" data-id="element-36">
              Cuando dices SÍ hoy, también recibes este regalo estratégico{' '}
              <span className="text-sage italic font-light" data-id="element-37">
                (valorado en $13 USD)
              </span>{' '}
              — completamente gratis.
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-12" data-id="element-38">
          {bonuses.map((bonus, index) => <FadeIn key={bonus.id} delay={index * 0.1} data-id="element-39">
              <div className="bg-white rounded-3xl shadow-xl border border-sage/10 relative overflow-hidden" data-id="element-40">
                <div className="absolute top-0 right-0 w-32 h-32 bg-mint/50 rounded-bl-full -z-10" data-id="element-41"></div>

                <div className="flex flex-col md:flex-row" data-id="element-42">
                  {/* Image */}
                  <div className="md:w-1/3 p-6 md:p-8 flex items-center justify-center bg-cream/30" data-id="element-43">
                    <img src={bonus.image} alt={bonus.title} className="w-40 md:w-full max-w-[200px] rounded-xl shadow-lg object-cover" data-id="element-44" />
                  </div>

                  {/* Content */}
                  <div className="md:w-2/3 p-8 md:p-10" data-id="element-45">
                    <div className="inline-flex items-center gap-2 bg-gold/20 text-forest font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-46">
                      <span className="uppercase" data-id="element-47">Bono #{bonus.id}</span>
                      <span className="w-1 h-1 rounded-full bg-forest/30" data-id="element-48"></span>
                      <span data-id="element-49">GRATIS — Valor ${bonus.value} USD</span>
                    </div>

                    <h3 className="text-2xl md:text-3xl font-bold text-forest mb-2" data-id="element-50">
                      {bonus.title}
                    </h3>
                    <h4 className="text-lg text-sage font-medium italic mb-6" data-id="element-51">
                      {bonus.subtitle}
                    </h4>

                    <p className="text-gray-700 mb-8 leading-relaxed" data-id="element-52">
                      {bonus.description}
                    </p>

                    <div className="border-t border-gray-100 pt-6" data-id="element-53">
                      <p className="text-gray-500 italic text-sm mb-4" data-id="element-54">
                        <span className="font-semibold text-gray-700 not-italic" data-id="element-55">
                          Por qué esto vale ${bonus.value} USD:
                        </span>{' '}
                        {bonus.why}
                      </p>
                      <p className="text-xl font-bold text-sage" data-id="element-56">
                        Tuyo hoy: GRATIS.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}